import { navLinks } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2">
                <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-movie-2-fill text-lg"></i>
                </span>
                <span className="font-heading text-lg font-semibold text-background-50">樱桃视频</span>
              </div>
              <p className="mt-4 max-w-md text-sm text-background-100/80 leading-relaxed">
                本站为樱桃视频的入口与地址指引页面，提供最新地址、官网入口辨识方法、
                App 下载与安装教程，以及防走失与安全提醒。建议收藏本页，方便随时访问。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-sm font-semibold text-background-50">页面导航</h3>
              <ul className="mt-4 grid grid-cols-2 gap-2">
                {navLinks.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-background-100/80 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-100/70">
              © {year} 樱桃视频 · 最新地址与官网入口指引页
            </p>
            <p className="text-xs text-background-100/70">
              本页仅提供入口与使用指引，请配合当地法律法规合理使用网络服务。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}